export default [
  {
    content: "사용 전 설비 내부를 청소하거나 환기하고 있는가?",
    isChecked: "",
  },
  {
    content: "발생하는 가스·증기 또는 분진 중 화재·폭발 위험물질은 안전한 장소로 배출하고 있는가?",
    isChecked: "",
  },
  {
    content: "건조물은 쉽게 이탈되지 않도록 하였는가?",
    isChecked: "",
  },
  {
    content: "고온으로 가열 건조한 가연성 물질은 발화의 위험이 없는 온도로 냉각한 후에 다음 공정으로 이송하는가?",
    isChecked: "",
  },
  {
    content: "건조설비의 상부나 근접한 곳에 가연성 물질을 보관하고 있지 않은가?",
    isChecked: "",
  },
  {
    content: "건조실 내부 온도측정장치의 기능이 정상적으로 유지되고 있는가?",
    isChecked: "",
  },
  {
    content: "건조실 내부 자동온도제어장치의 기능이 정상적으로 유지되고 있는가?",
    isChecked: "",
  },
  {
    content: "건조실 내부 폭발 시 폭발구(방산구)는 정상 작동하는가?",
    isChecked: "",
  },
  {
    content: "배기구의 역화방지기는정상 작동하는가?",
    isChecked: "",
  },
  {
    content: "배기덕트의 점검구와 청소구는 정상 작동하는가?",
    isChecked: "",
  },
  {
    content: "화재감지기 및 경보기는 정상 작동하는가?",
    isChecked: "",
  },
  {
    content: "소화설비는 정상 작동하는가? 또 규정된 장소에 배치되어 있는가?",
    isChecked: "",
  },
];
